
import SocialNetworks from '@web/components.v2/Settings/SocialNetworks/index.vue'

export default {
  components: {
    SocialNetworks
  }
}
